module.exports = __webpack_public_path__ + "static/logo-wbac-large-ca37ab44344d2aa1ddb2361858b7b7f2.png";